import _HomeAcquisitionService from "../services/home-acquisition-service";
import { IHomeAcquisitionService } from "../types/services/home-acquisition-service";

const HomeAcquisitionService: IHomeAcquisitionService = new _HomeAcquisitionService();

export default HomeAcquisitionService;
